import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'saveLoad',
  initialState: {
    google: {
      isApiLoaded: false,
      isSignedIn: false,
      isFileListLoading: false,
      files: [],
      nextPageToken: null,
    },
    fileExistsPrompt: null,
  },
  reducers: {
    driveApiLoadSuccess(state) {
      state.google.isApiLoaded = true;
    },
    driveApiSignedIn(state) {
      state.google.isSignedIn = true;
    },
    driveApiSignedOut(state) {
      state.google.isSignedIn = false;
    },
    driveFileListStarted(state, { payload }) {
      state.google.isFileListLoading = true;
      if (payload.first) {
        state.google.nextPageToken = null;
        state.google.files = [];
      }
    },
    driveFileListResults(state, { payload }) {
      const { files, nextPageToken } = payload;
      state.google.isFileListLoading = false;
      state.google.files = state.google.files.concat(files);
      state.google.nextPageToken = nextPageToken;
    },
    showFileExistsPrompt(state, { payload }) {
      state.fileExistsPrompt = payload;
    },
    hideFileExistsPrompt(state) {
      state.fileExistsPrompt = null;
    },

    // Action that gets dispatched when a file is saved so that the
    // canvas reducer can update its fileInfo.
    fileSaved() {},
  },
});

export default slice;
